/**
 * The VideoJS class to initialize a video
 */

export default class VideoJS {
	constructor(arrayOfVideos) {
		this.videos = arrayOfVideos;

		this.createPlayer();
	}

	createPlayer() {
		this.videos.forEach( element => {

			// prevent safari from pausing section background image
			if (element.parentElement.classList.contains('et_pb_section_video_bg')) return;

			/* eslint-disable-next-line */
			var video = videojs(element, {
				controls: typeof element.attributes.controls != 'undefined',
				muted: typeof element.attributes.muted != 'undefined'
			})

			if( element.nextElementSibling && typeof element.nextElementSibling.classList != 'undefined' && element.nextElementSibling.classList.contains('btn-preview') )
			{
				element.nextElementSibling.addEventListener( 'click', function( e ){
					e.preventDefault()

					video.muted( false )
					video.controls( true )
					video.play()	
				})
			}
		})
	}
}